import { createCtx } from "@reatom/framework";
import { reatomContext } from "@reatom/npm-react";
import { createRoot } from "react-dom/client";

import "./index.scss";

import App from "./App";
import { appConfig } from "./config";
import { Providers } from "./providers";

document.documentElement.dataset.brand = appConfig.id;

const root = createRoot(document.getElementById("root") as HTMLElement);

export const ctx = createCtx();

root.render(
  <reatomContext.Provider value={ctx}>
    <Providers>
      <App />
    </Providers>
  </reatomContext.Provider>,
);
